import { createPromiseActionTypes } from "../../utils/redux";

export const LOGIN = createPromiseActionTypes("auth/LOGIN");
export const LOGIN_ERROR = "auth/LOGIN_ERROR";
export const USER_GET = createPromiseActionTypes("auth/USER_GET");
export const USER_LOCATION_SET = "auth/USER_LOCATION_SET";
export const MESSAGE_NEW = "auth/MESSAGE_NEW";
export const USER_MESSAGES_CLEAR = "auth/USER_MESSAGES_CLEAR";
